var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_4747)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 27.75C24.48 27.75 23.25 26.52 23.25 25C23.25 23.48 24.48 22.25 26 22.25C27.52 22.25 28.75 23.48 28.75 25C28.75 26.52 27.52 27.75 26 27.75ZM26 23.75C25.31 23.75 24.75 24.31 24.75 25C24.75 25.69 25.31 26.25 26 26.25C26.69 26.25 27.25 25.69 27.25 25C27.25 24.31 26.69 23.75 26 23.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0003 31.75C33.8403 31.75 33.6903 31.7 33.5503 31.6C33.2203 31.35 33.1503 30.88 33.4003 30.55C34.6103 28.94 35.2503 27.02 35.2503 25C35.2503 22.98 34.6103 21.06 33.4003 19.45C33.1503 19.12 33.2203 18.65 33.5503 18.4C33.8803 18.15 34.3503 18.22 34.6003 18.55C36.0103 20.42 36.7503 22.65 36.7503 25C36.7503 27.35 36.0103 29.58 34.6003 31.45C34.4503 31.65 34.2303 31.75 34.0003 31.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 31.75C17.77 31.75 17.55 31.65 17.4 31.45C15.99 29.58 15.25 27.35 15.25 25C15.25 22.65 15.99 20.42 17.4 18.55C17.65 18.22 18.12 18.15 18.45 18.4C18.78 18.65 18.85 19.12 18.6 19.45C17.39 21.06 16.75 22.98 16.75 25C16.75 27.02 17.39 28.94 18.6 30.55C18.85 30.88 18.78 31.35 18.45 31.6C18.32 31.7 18.16 31.75 18 31.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8001 29.3499C30.6401 29.3499 30.4901 29.2999 30.3501 29.1999C30.0201 28.9499 29.9501 28.4799 30.2001 28.1499C30.8901 27.2399 31.2501 26.1499 31.2501 24.9999C31.2501 23.8499 30.8901 22.7599 30.2001 21.8499C29.9501 21.5199 30.0201 21.0499 30.3501 20.7999C30.6801 20.5499 31.1501 20.6199 31.4001 20.9499C32.2801 22.1299 32.7501 23.5299 32.7501 24.9999C32.7501 26.4699 32.2801 27.8799 31.4001 29.0499C31.2501 29.2499 31.0301 29.3499 30.8001 29.3499Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2 29.3499C20.97 29.3499 20.75 29.2499 20.6 29.0499C19.72 27.8699 19.25 26.4699 19.25 24.9999C19.25 23.5299 19.72 22.1199 20.6 20.9499C20.85 20.6199 21.32 20.5499 21.65 20.7999C21.98 21.0499 22.05 21.5199 21.8 21.8499C21.11 22.7599 20.75 23.8499 20.75 24.9999C20.75 26.1499 21.11 27.2399 21.8 28.1499C22.05 28.4799 21.98 28.9499 21.65 29.1999C21.52 29.2999 21.36 29.3499 21.2 29.3499Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_4747",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_4747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_4747",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.efa697cc8bc3e8565e6a494f5b097dc2.svg";
export { ForwardRef as ReactComponent };